import classNames from 'classnames';
import {
  Button,
  FlexContainer,
  Spinner,
  Txt,
  Modal,
  VerifyPassword,
} from 'components';
import { useState } from 'react';
import styles from './DeleteProperty.module.scss';

/**
 * DeleteProperty
 *
 * @return {JSX.Element}
 */
const DeleteProperty = ({ className, isLoading, onDelete, disabled }) => {
  const [isConfirm, setIsConfirm] = useState(false);

  const handleClick = () => setIsConfirm(true);

  const handleSuccessConfirm = () => {
    setIsConfirm(false);
    onDelete();
  };

  const handleCloseConfirm = () => setIsConfirm(false);

  return (
    <FlexContainer
      className={classNames(
        styles.DeleteProperty,
        className,
        DeleteProperty.displayName
      )}
      column
    >
      <FlexContainer>
        <Button
          flex
          big
          warn
          disabled={disabled || isLoading}
          onClick={handleClick}
        >
          {isLoading ? (
            <Spinner />
          ) : (
            <FlexContainer spaceBetween alignCenter flex>
              <Txt xx>Delete property</Txt>
            </FlexContainer>
          )}
        </Button>
      </FlexContainer>
      {isConfirm ? (
        <Modal onClose={handleCloseConfirm}>
          <VerifyPassword
            className={styles.VerifyPassword}
            onSuccess={handleSuccessConfirm}
          />
        </Modal>
      ) : null}
    </FlexContainer>
  );
};

DeleteProperty.displayName = 'DeleteProperty';

export default DeleteProperty;
